module.exports = __webpack_public_path__ + "static/media/red-morley-hewitt-rl44UgsiObY-unsplash.66ffd161.jpg";